// extracted by mini-css-extract-plugin
export default {"page":"LevelChoice_page__oDapU"};